export default {
  loginIn: "登錄",//登录按钮
  loginOut: "退出",
  currentAccount: "當前賬號",
  emptyMsg: "當前賬號下未發現角色，換個賬號試試吧",
  validMsg: "最近一次在玩的遊戲角色:",
  goNewGame: "開始新遊戲",
  reLogin: "重新登錄",
  loginDig: "登錄",//弹出框登录提示
  expirationTime: "30天內保持登錄狀態",
  goto: "前往",
  haveRoles: "查看其他已擁有的角色",
  gameDes: "遊戲介紹",
  moreGame: "更多遊戲",
  // 邮箱登录
  forgetPas:"忘記密碼？",
  changePas:"重置密碼",
  passwordHolder:"請輸入密碼",
  codeHolder:"請填寫驗證碼",
  getCode:"獲取驗證碼",
  newPasswordHolder:"請輸入新密碼",
  newPasswordHolder2:"請再次輸入新密碼",
  newPasswordError:"兩次輸入密碼不一致！",
  codeLimit:"長度在4到6個字符",
  passwordLimit:"長度在4到20個字符",
  loginSuccess:"登錄成功",
  codeSend:"已發送驗證碼",
  pasSendSuccess:"密碼修改成功",
  // 支付弹框
  pleaseConfirm: "請確認",
  payType: "支付方式",
  immediatePay: "立即支付",
  choosePayType: "請選擇支付方式",
  // 导航部分
  recharge: "儲值中心",
  persion: "個人中心",
  myGame: "我的遊戲",
  myOrder: "我的訂單",
  customer: "客戶服務",
  hotQuestion: "熱門問題",
  connectService: "聯繫客服",
  // 首页 footer
  address: "2013-2020",
  company: "遊斐網絡",
  aboutOur: "關於我們",
  careOur: "關注我們",
  agreement: "用戶使用協議",
  privacy: "隱私政策",
  // 充值页面
  game: "遊戲",
  gameHolder: "請選擇遊戲",
  server: "區服",
  serverHolder: "請選擇區服",
  role: "角色",
  roleHolder: "請選擇角色",
  rechargeGear: "儲值檔位",
  usuallyGoods: "日常禮包",
  limitGoods: "限定禮包",
  jfdh:"積分兌換",
  qiandao:"簽到禮包",
  searchGoods: "搜索禮包",
  purchase: "購買",
  confirmAccount: "請確認賬號",
  payconfirmHolder: "請確認是否儲值",
  payContinue: "重新支付",
  payOver: "已完成支付",
  goodsEmpty: "請選擇購買物品",
  payTipMsg1: "請您在新打開的視窗完成支付！",
  payTipMsg2: "支付完成前請不要關閉此窗口。",
  // 我的游戏
  roleName: "角色名稱",
  roleId: "角色ID",
  roleName: "角色名稱",
  roleLeavel: "角色等級",
  vipLeavel: "VIP等級",
  interestedGame: "可能感興趣的遊戲",
  playGame: "開始遊戲",
  goRecharge: "去儲值",
  // 我的订单
  dateTimeRange: "時間",
  startTime: "開始時間",
  endTime: "結束時間",
  to: "至",
  nickName: "暱稱",
  goodsName: "禮包/遊戲貨幣",
  price: "價格",
  orderId: "訂單號",
  rechargeTime: "儲值時間",
  orderState: "訂單狀態",
  paySuccess: "支付成功",
  orderClose: "已關閉",
  doPay: "支付",
  doClose: "關閉",
  noData: "暫無數據",
  search: "查詢",
  confirm: "確定",
  tip: "提示",
  colseConfirm: "確定要關閉訂單嗎?",
  colseSuccess: "關閉成功",
  // 联系客服
  feedBack: "官網儲值問題反饋",
  questionTime: "發生時間",
  questionTimeHolder: "請選擇發生時間",
  email: "郵箱",
  emailHolder: "請填寫郵箱",
  describe: "問題描述",
  describeHolder: "請填寫問題描述",
  screenshot: "相關截圖",
  cancel: "取消",
  submit: "提交",
  submitSuccess: "提交成功",
  emailNotEmpty: "郵箱不能為空",
  emailFormat: "請輸入正確的郵箱格式",
  desEmpty: "問題描述不能為空",
  desMore: "問題描述不能超過255字",
  imgTypeError: "圖片文件格式錯誤！",
  imgSizeError: "圖片大小不能超過3MB!",
  // 公司介绍页面
  companyProfile: "公司簡介",
  companyDes: "遊斐網絡成立於2013年，總部位於上海，是一家專業從事移動遊戲自主研發、運營發行的綜合遊戲開發商。",
  developmentHis: "發展歷程",
  developmentDes1: "自2013年8月成立以來，公司隊伍不斷發展壯大，從成員結構單一到多個項目同時推進，逐步積累了豐富的移動遊戲開發經驗，產品覆蓋多種遊戲類型，致力於打造前所未有的完美遊戲體驗。",
  developmentDes2: "憑藉自身強大的自研實力，遊斐深耕移動遊戲的自主研發，同時不斷在運營發行等領域進行探索和拓展，加速提升自身品牌及行業影響力，積極推出高端精品遊戲，塑造、維護健康良好的遊戲生態。",
  developmentDes3: "在未來，遊斐還將持續探索，推出更多誠意之作。",
  Telephone: "電話",
  Fax: "傳真",
  country: "國家",
  countryHolder: "請選擇國家",
  countryList: [
    { countryId: 360, countryName: '印度尼西亞', currency: "IDR" },
    // { countryId: 608, countryName: '菲律宾', currency: "PHP" },
    { countryId: 458, countryName: '馬來西亞', currency: "MYR" },
    { countryId: 702, countryName: '新加坡', currency: "SGD" },
    // { countryId: 764, countryName: '泰國', currency: "THB" },
    // { countryId: 104, countryName: '緬甸', currency: "MMK" },
    // { countryId: 418, countryName: '老撾', currency: "LAK" },
    // { countryId: 116, countryName: '柬埔寨', currency: "USD" },
    // { countryId: 626, countryName: '東帝汶', currency: "USD" }
  ]
}


// WEBPACK FOOTER //
// ./src/common/lang/zh-TW.js